import { render } from "./CommentProcessingIcon.vue?vue&type=template&id=70717d16"
import script from "./CommentProcessingIcon.vue?vue&type=script&lang=js"
export * from "./CommentProcessingIcon.vue?vue&type=script&lang=js"
script.render = render

export default script